"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDimensionsDiagramFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30 7V5h-8v2h3v18h-3v2h8v-2h-3v-3h2v-2h-2v-3h2v-2h-2v-3h2v-2h-2V7h3zM2.05 10.29v11.47L12 27.5l9.94-5.74V10.29L12 4.55zM16 16a4 4 0 11-4-4 4 4 0 014 4z" })));
}
exports.default = SvgDimensionsDiagramFilled;
//# sourceMappingURL=DimensionsDiagramFilled.js.map